// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1_VC_","menu":"styles_menu__207V3","iconContainer":"styles_iconContainer__2VVZV"};